import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface EditDemandBookingConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onEditThisBooking: () => void;
  onEditAllLinkedBookings: () => void;
}

export function EditDemandBookingConfirmDialog({
  open,
  onCancel,
  onEditThisBooking,
  onEditAllLinkedBookings,
}: EditDemandBookingConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Edit Open Demand Booking</AlertDialogTitle>
          <AlertDialogDescription>
            Do you want to edit this booking only, or all bookings linked to this accepted demand plan?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onEditThisBooking}
            className="bg-primary text-primary-foreground hover:bg-primary/90"
          >
            This booking
          </AlertDialogAction>
          <AlertDialogAction
            onClick={onEditAllLinkedBookings}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            All linked demand bookings
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
